/**
 * Domain types for Records feature
 * Clean Architecture - Domain Layer
 */

// Record Status Enum
export enum RecordStatus {
  AudioSaved = "AudioSaved",
  Uploading = "Uploading",
  Processing = "Processing",
  InProgress = "InProgress",
  Finished = "Finished",
  Error = "Error",
}

// Report Language Enum
export enum Language {
  SameAsTranscript = "Same as Transcript",
  // Main languages
  English = "English",
  GlobalEnglish = "Global English",
  AustralianEnglish = "Australian English",
  BritishEnglish = "British English",
  USEnglish = "US English",
  Russian = "Russian",
  Spanish = "Spanish",
  French = "French",
  German = "German",
  Italian = "Italian",
  Portuguese = "Portuguese",
  Dutch = "Dutch",
  Chinese = "Chinese",
  Japanese = "Japanese",
  Korean = "Korean",
  Hindi = "Hindi",
  Turkish = "Turkish",
  Polish = "Polish",
  Ukrainian = "Ukrainian",
  Romanian = "Romanian",
  Czech = "Czech",
  Swedish = "Swedish",
  Hungarian = "Hungarian",
  Finnish = "Finnish",
  Norwegian = "Norwegian",
  NorwegianNynorsk = "Norwegian Nynorsk",
  Danish = "Danish",
  Greek = "Greek",
  Bulgarian = "Bulgarian",
  Croatian = "Croatian",
  Slovak = "Slovak",
  Slovenian = "Slovenian",
  Lithuanian = "Lithuanian",
  Latvian = "Latvian",
  Estonian = "Estonian",
  Icelandic = "Icelandic",
  Catalan = "Catalan",
  Galician = "Galician",
  Basque = "Basque",
  Breton = "Breton",
  Welsh = "Welsh",
  Arabic = "Arabic",
  Hebrew = "Hebrew",
  Persian = "Persian",
  Urdu = "Urdu",
  Bengali = "Bengali",
  Tamil = "Tamil",
  Gujarati = "Gujarati",
  Kannada = "Kannada",
  Malayalam = "Malayalam",
  Telugu = "Telugu",
  Thai = "Thai",
  Marathi = "Marathi",
  Indonesian = "Indonesian",
  Malay = "Malay",
  Vietnamese = "Vietnamese",
  Tagalog = "Tagalog",
  Swahili = "Swahili",
  Afrikaans = "Afrikaans",
  Kazakh = "Kazakh",
  Uzbek = "Uzbek",
  Turkmen = "Turkmen",
  Azerbaijani = "Azerbaijani",
  Belarusian = "Belarusian",
  Armenian = "Armenian",
  Mongolian = "Mongolian",
  Nepali = "Nepali",
  Sinhala = "Sinhala",
  Lao = "Lao",
  // New languages from AssemblyAI
  Albanian = "Albanian",
  Amharic = "Amharic",
  Assamese = "Assamese",
  Bashkir = "Bashkir",
  Bosnian = "Bosnian",
  Faroese = "Faroese",
  Georgian = "Georgian",
  Haitian = "Haitian",
  Hausa = "Hausa",
  Hawaiian = "Hawaiian",
  Javanese = "Javanese",
  Latin = "Latin",
  Lingala = "Lingala",
  Luxembourgish = "Luxembourgish",
  Macedonian = "Macedonian",
  Malagasy = "Malagasy",
  Maltese = "Maltese",
  Maori = "Maori",
  Occitan = "Occitan",
  Panjabi = "Panjabi",
  Pashto = "Pashto",
  Sanskrit = "Sanskrit",
  Serbian = "Serbian",
  Shona = "Shona",
  Sindhi = "Sindhi",
  Somali = "Somali",
  Sundanese = "Sundanese",
  Tajik = "Tajik",
  Tatar = "Tatar",
  Yiddish = "Yiddish",
  Yoruba = "Yoruba",
}

// Report Types
export type ReportType = "General" | "JTBD" | "Q&A" | "Persona" | "Custom";

// File Types
export type FileType = "audio" | "video" | "text";

// Available Versions Map
export type AvailableVersions = Record<string, number[]>;

// Domain Entity IDs
export type RecordId = string;
export type VersionId = number;

// Validation Result
export interface ValidationResult {
  isValid: boolean;
  errors: string[];
}

// Token Calculation Result
export interface TokenCalculation {
  requiredTokens: number;
  hasEnoughTokens: boolean;
  displayText: string;
  isError: boolean;
}
